import { SelectBox } from '../../../common/SelectBox/SelectBox';
import { PriceBoxContent } from '../PriceBoxContent';

export const ComparePriceButton = ({ selected, price, contractName, isDefaultContract, onClick }) => {
    return (
        <SelectBox onClick={onClick} selected={selected} height="220px">
            <PriceBoxContent
                price={price}
                contractName={contractName}
                isDefaultContract={isDefaultContract}
                selected={selected}
            />
        </SelectBox>
    );
};
